import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const ENTRY = `${API_URL}/meeting-spaces`;

getSharedMeetingSpacesCount.operation = 'READ';
getSharedMeetingSpacesCount.idFrom = 'ARGS';
export function getSharedMeetingSpacesCount(minUpdatedDate: Date | null) {
    return get<{ count: number }>(`${ENTRY}/shared-count`, {
        getData: { minUpdatedDate: minUpdatedDate?.toISOString?.() },
    });
}
